module.exports = {"id":"201013","name":"Łukasz Teodorczyk","rating":"76","photo":"./data/images/photos/2/201013.png","club":{"name":"RSC Anderlecht","logo":"./data/images/clubs/RSCAnderlecht.png"},"positions":["BU"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ŁukaszTeodorczyk0.json
// module id = 4482
// module chunks = 0